import i18n from 'i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { lang } from './models';

const languages = ["en", "fr", "ar"];

i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    fallbackLng: lang,//'en',
    fallbackNSL: 'translation',
    debug: false,
    whitelist: languages,
    detection: {
        order: ["localStorage", "htmlTag", "cookie", "path", "subdomain"],
        caches: ["cookie"],
    },
    react: { useSuspense: false },
    /* backend: {
        loadPath: "./assets/locales/{{lng}}/{{ns}}.json",
        crossDomain: true,
    }, */
    interpolation: {
        escapeValue: false
    }
})

export default i18n